import { useNavigationHandler } from "../contexts/Navigation";
import { routerPaths } from "../utils/routerPaths";
import usePathChunk from "./usePathChunk";

const buttonVisibilityConfig = {
  [routerPaths.home]: {
    hideResumeLaterButton: true,
    hideFooter: true,
    hideHeader: true,
  }
};

const useFooterVisibility = () => {
  const { currentStep } = useNavigationHandler();
  const { getPathChunk } = usePathChunk();

  const sectionConfig = buttonVisibilityConfig[`/${getPathChunk()}`];
  const stepConfig = sectionConfig?.steps?.[currentStep];

  const shouldHideFooter = () => {
    if (!sectionConfig) {
      return false;
    }
    if (sectionConfig.hideFooter) {
      return true;
    }
    if (stepConfig?.hideFooter) {
      return true;
    }
    return false;
  };

  const shouldHideHeader = () => {
    if (!sectionConfig) {
      return false;
    }
    if (sectionConfig.hideHeader) {
      return true;
    }
    if (stepConfig?.hideHeader) {
      return true;
    }
    return false;
  };

  const shouldHideContinueButton = () => {
    if (!sectionConfig) {
      return false;
    }
    if (stepConfig?.hideContinueButton) {
      return true;
    }
    return false;
  };

  const shouldHideBackButton = () => {
    if (!sectionConfig) {
      return false;
    }
    if (stepConfig?.hideBackButton) {
      return true;
    }
    return false;
  };

  const shouldHideResumeLaterButton = () => {
    if (!sectionConfig) {
      return false;
    }
    return !!sectionConfig?.hideResumeLaterButton;
  };

  return {
    shouldHideFooter: shouldHideFooter(),
    shouldHideContinueButton: shouldHideContinueButton(),
    shouldHideBackButton: shouldHideBackButton(),
    shouldHideHeader: shouldHideHeader(),
    shouldHideResumeLaterButton: shouldHideResumeLaterButton(),
  };
};

export default useFooterVisibility;
